import Vue from 'vue'

Vue.filter('formatAmount', amount => {
  let money = ''
  if (amount) {
    money = parseInt(amount) + ''
    if (money.length > 4) {
      money = money.slice(0, -4) + '万'
    }
  }
  return money
})

Vue.filter('cutCardEndFourPlaces', cardNum => {
  return cardNum ? cardNum.substr(cardNum.length - 4) : ''
})

Vue.filter('encryptMobile', mobile => {
  return mobile.substr(0, 3) + '****' + mobile.substr(-4)
})
